import type { CSSProperties } from 'react';
import { neonVar } from '@/utils/neon-utils';

export const EMPTY_PLANS_OF_STUDY_ILLUSTRATION_STYLE: CSSProperties = {
  width: 236,
  height: 157,
  opacity: 1,
};

export const EMPTY_PLANS_OF_STUDY_TITLE_STYLE: CSSProperties = {
  fontFamily: neonVar('font-family', 'Roboto, Arial, Helvetica, sans-serif'),
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '1.5rem',
  lineHeight: '1.5em',
  letterSpacing: 0,
  color: '#333333',
  margin: 0,
};

export const EMPTY_PLANS_OF_STUDY_BODY_STYLE: CSSProperties = {
  fontFamily: neonVar('font-family', 'Roboto, Arial, Helvetica, sans-serif'),
  fontWeight: 400,
  fontSize: '0.875rem',
  lineHeight: '1.5em',
  letterSpacing: 0,
  color: '#333333',
};

export const EMPTY_PLANS_OF_STUDY_CARD_STYLE: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1rem',
};
